
define('unknown/models/registerModel',[
	'jquery',
	'underscore',
	'backbone'
], function($, _, Backbone){
	var Register = Backbone.Model.extend({
		urlRoot:"/draftapp/users",
		defaults: {
			userName: null,
			password: null,
			email: null
	    },

	    initialize: function() {
	    	
	    },
	});
	
	return Register;  
});